import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/images/logo.svg";
import "./Navbar.css";
import Resume from "../../assets/pdf/resume.pdf";
import { useScroll } from "./UseScroll";
import { Bounce, Fade } from "react-awesome-reveal";
const Navbar = () => {
    const [btnState, setbtnState] = useState(false);
    const { scrollDirection } = useScroll();
    const location = useLocation();
    const navigate = useNavigate();

    const scrollToSection = (sectionId) => {
        setbtnState(false); // Close mobile menu
        const navbarHeight = 100; // Offset for fixed navbar

        const scrollToElement = () => {
            const element = document.getElementById(sectionId);
            if (element) {
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: elementPosition - navbarHeight,
                    behavior: "smooth"
                });
            }
        };

        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(scrollToElement, 100);
        } else {
            scrollToElement();
        }
    };

    const styles = {
        active: {
            visibility: "visible",
            transition: "all 0.5s",
        },
        hidden: {
            visibility: "hidden",
            transition: "all 0.5s",
            transform: "translateY(-100%)",
        },
    };
    const homieScroll = () => {
        if (window.pageYOffset) {
            return scrollDirection === "down" ? styles.active : styles.hidden;
        }
    };

    function handleMenuIconClick(event) {
        setbtnState((btnState) => !btnState);
    }

    let toggleClassCheck = btnState ? "change" : "";

    return (
        <nav style={homieScroll()}>
            <div className="container">
                <div className="logo">
                    <Bounce>
                        <Link to="/">
                            <Logo width="50" height="50" />
                        </Link>
                    </Bounce>
                </div>
                <div className={btnState ? "nav-links-mobile" : "links"}>
                    <ul>
                        <Fade direction="down" duration={200} cascade damping={0.8}>
                            <li>
                                <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection("about"); }}>
                                    <span>01.</span>About
                                </a>
                            </li>
                            <li>
                                <a href="#experience" onClick={(e) => { e.preventDefault(); scrollToSection("experience"); }}>
                                    <span>02.</span>Experience
                                </a>
                            </li>
                            <li>
                                <a href="#work" onClick={(e) => { e.preventDefault(); scrollToSection("work"); }}>
                                    <span>03.</span>Work
                                </a>
                            </li>
                            <li>
                                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection("contact"); }}>
                                    <span>04.</span>Contact
                                </a>
                            </li>
                            <li>
                                <Link
                                    id="button"
                                    className="button"
                                    target="_blank"
                                    download
                                    to={Resume}
                                >
                                    Resume
                                </Link>
                            </li>
                        </Fade>

                        <div
                            id="menu-btn"
                            onClick={() => handleMenuIconClick()}
                            className={`menu-icon ${toggleClassCheck}`}
                        >
                            <div className="menu-icon-container">
                                <div className="bar1"></div>
                                <div className="bar2"></div>
                                <div className="bar3"></div>
                            </div>
                        </div>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
